import React from 'react'
import { Outlet, Navigate} from 'react-router-dom'
// import { useEffect} from "react";
export default function PrivateRoutes() {
    let  user = localStorage.getItem("token") == null ? false : true;
    return (
        <>
            {user ? <Outlet  /> : <Navigate to="/" />};
        </>

    )

}
